module.exports = __webpack_public_path__ + "static/img/3.6cb7a093.png";